import styled from 'styled-components';
import {StyledField as FormField} from '../Form.styled';
import colors from '../../../../lib/Colors';
import React from 'react';

const StyledField = styled(({error, helper, ...props}) => <FormField {...props}/>)`
  padding: 10px 75px 0 5px !important;
  &:focus {
    margin-bottom: ${props => (
  (props.error || props.helper) ? '0' : '1.5rem'
)}}
  ${props => (
  props.error && {
    borderBottomColor: `${colors.red} !important`,
    marginBottom: 0
  } || {
    marginBottom: '1.5rem',
    borderBottomColor: `${colors.blue} !important`
  }
)}
`;

const StyledPasswordValidation = styled.div`
  height: 0;
  opacity: 0;
  visibility: hidden;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 99%;
  transition:
    height 0.2s ease-in-out,
    opacity 0.2s ease-in-out
  ;
  input:focus ~ & {
    visibility: visible;
    opacity: 1;    
    height: 20px;
    margin-bottom: 0.5rem;
  };
`;

const StyledStageBox = styled.div`
  margin: 5px 0 0;
`;

const StageLabel = styled.label`
  margin: 5px 0 0 5px;
  color: ${colors.mediumGray};
`;

const Dot = styled(({state, ...props}) => (<div {...props}/>))`
  margin: 0 0 0 5px;
  height: 10px;
  width: 10px;
  background-color: ${({state}) => state ? colors.colorSuccess : colors.gray};
  border-radius: 50%;
  display: inline-block;
`;

const ShowButton = styled.div`
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: 12px;
  width: 65px;
`;

const ShowLabel = styled.label`
  position: absolute;
  cursor: pointer;
  font-size: 0.875em;
  margin-left: 0.5rem;
`;

export {
  StyledField,
  ShowButton,
  StyledPasswordValidation,
  Dot,
  StyledStageBox,
  StageLabel,
  ShowLabel,
};
